import { Grid, Typography } from "@mui/material"
import FormUploadFile from "components/Form/FormComponents/FormUploadFile/FormUploadFile"
import { apiEndpoints } from "generated/apiEndpoints"
import { IAttachment, IAttachmentInfo } from "../violation.interface"
import { useEffect, useState } from "react"

import FormPreviewFileThumbnail from "components/Form/FormComponents/FormUploadFile/FormPreviewFileThumbnail"
import { useApi } from "auth/useApi"
import { IApiFunc, IApiResult } from "auth/interface/api.interface"
import { useTranslation } from "react-i18next"

export const Attachment: React.FC<IAttachmentInfo> = (props) => {
  const { values, setFieldValue, isAdmin, isViewing } = props
  const [fileResult, fileApi] = useApi() as [IApiResult, IApiFunc]
  const [fileUploadResult, fileUploadApi] = useApi() as [IApiResult, IApiFunc]
  const [attachments, setAttachments] = useState<IAttachment[]>(
    values.attachments.filter((x) => x.isAdmin === isAdmin)
  )
  const { t } = useTranslation("translation")

  useEffect(() => {
    if (fileUploadResult.status !== 2) return
    setAttachments((prevStats) => [...fileUploadResult.data, ...prevStats])
  }, [fileUploadResult])

  const removeFile = (filePath: string) => {
    const fileParams = filePath.split("/")
    const feature = fileParams.slice(0, -1).join("/")
    const fileName = fileParams[fileParams.length - 1]
    fileApi.del(
      apiEndpoints.attachment.deleteattachment.replace("{fileid}", fileName) + `?feature=${feature}`
    )

    setAttachments(
      attachments.filter((attachment) => {
        const filePath = attachment.fileId.split("/")
        const attachmentFileName = filePath[filePath.length - 1]
        return attachmentFileName !== fileName
      })
    )
  }

  useEffect(() => {
    attachments.map((att: IAttachment) => (att.isAdmin = isAdmin))
    setFieldValue("attachments", attachments)
  }, [attachments])

  const handleChange = (files: File[]) => {
    if (files.length === 0) return
    const url = apiEndpoints.attachment.addattachment.replace("{feature}", "violation")
    files.forEach((file) => {
      fileUploadApi.file(url, file)
    })
  }

  return (
    <>
      {!isViewing && (
        <Grid item xs={12}>
          <FormUploadFile handleChange={handleChange} />
        </Grid>
      )}

      <Grid item xs={12} marginBottom={2}>
        <Typography variant="h4">{t("global.media", "Media")}</Typography>
      </Grid>
      {attachments &&
        attachments.map((attachment: IAttachment) => (
          <Grid item xs={12} md={6}>
            <FormPreviewFileThumbnail
              Data={attachment.base64}
              fileId={attachment.fileId}
              fileName={attachment.fileName}
              dontShowDeleteButton={isViewing}
              removeFile={removeFile}
              name={""}
            />
          </Grid>
        ))}
    </>
  )
}
